var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEMarSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0424 15.25V22M22.0424 22V28.75M22.0424 22H15.2924M22.0424 22H28.7924M26.5424 42.25H17.5424L16.3026 36.67C14.8273 36.0928 13.4475 35.2963 12.2099 34.3075L6.75586 36.0242L2.25586 28.2303L6.46786 24.3647C6.23027 22.7987 6.23027 21.2058 6.46786 19.6398L2.25586 15.772L6.75586 7.978L12.2099 9.69475C13.4481 8.70491 14.8286 7.90768 16.3049 7.33L17.5424 1.75H26.5424L27.7821 7.33C29.2574 7.90719 30.6372 8.70365 31.8749 9.6925L37.3289 7.97575L41.8289 15.7697L37.6169 19.6353C37.8545 21.2013 37.8545 22.7942 37.6169 24.3602L41.8289 28.2258L37.3289 36.0198L31.8749 34.303C30.6375 35.2934 29.2577 36.0914 27.7821 36.67L26.5424 42.25Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMarSettings);
export default __webpack_public_path__ + "static/media/eMARSettings.3cdadcbc718f152b0335ac553df18344.svg";
export { ForwardRef as ReactComponent };